import { Pipe, PipeTransform, OnDestroy } from "@angular/core";
import { GlobalDataService } from "../providers/global-data.service";
import { distinct } from 'rxjs/operators';
import { from, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Pipe({
    name: 'stringFilter',
    standalone: false
})

export class StringFilterPipe implements PipeTransform, OnDestroy {

    tempData: any[] = [];
    private destroy$ = new Subject<void>();
 
    itemsFiltrati: any; // variabile che conterra' l'oggetto filtrato nella barra di ricerca in Anagrafica Clienti

    constructor(public globalData: GlobalDataService) { }
    
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    
    transform(items: any[], filter: string) {
        if (!filter || filter === '') {
            return items;
        }

        this.tempData = [];
        for (let i = 0; i < items.length; i++) {
            if ((items[i].nome.toLowerCase().indexOf(filter.toLowerCase()) !== -1)
                || (items[i].cognome.toLowerCase().indexOf(filter.toLowerCase()) !== -1)
                || (items[i].email.toLowerCase().indexOf(filter.toLowerCase()) !== -1)
                || (items[i].telefono.indexOf(filter) !== -1)) {
                this.tempData.push(items[i]);
            }
        }

        this.itemsFiltrati = [];
        from(this.tempData).pipe(
            distinct(),
            takeUntil(this.destroy$)
        ).subscribe(element => {
            this.itemsFiltrati.push(element);
        });

        return this.itemsFiltrati;
    }
}